// extracted by mini-css-extract-plugin
export default {"carrosselWrapper":"style_carrosselWrapper__qUSpt","carrossel":"style_carrossel__xicuD","logosContainer":"style_logosContainer__DTnUg"};